// dependencies imports ==>
import React, { useState } from "react";
// assets and scss imports ==>
import "./procedureCancelledUI.scss";
import Info from "../../../../assets/info.png";

const ProcedureCancelledUI = () => {
  const [openPopOver, setOpenPopOver] = useState(false);

  // Helper Methods ===>

  const getContent = () => {
    return (
      <div className="procedure-cancelled-hover-text-container">
        <i class="fa fa-caret-up" aria-hidden="true"></i>
        <div className="procedure-cancelled-hover-text">
          The particular procedure has been cancelled.
        </div>
      </div>
    );
  };

  // <===

  // Actions ===>

  const handleMouseOver = () => {
    setOpenPopOver(true);
  };

  const handleMouseOut = () => {
    setOpenPopOver(false);
  };

  // <===

  return (
    <div className="procedure-cancelled-ui-container">
      <img
        src={Info}
        alt=""
        className="procedure-cancelled-ui-info-icon"
        onMouseOver={() => {
          handleMouseOver();
        }}
        onMouseOut={() => {
          handleMouseOut();
        }}
      />
      {openPopOver && getContent()}
      <div className="procedure-cancelled-text">Cancelled</div>
    </div>
  );
};

export default ProcedureCancelledUI;
